import handleGetOrSearchFileProviderItemsResponse from './handleGetOrSearchFileProviderItemsResponse';
import { searchFileProviderItems as searchFileProviderItemsServiceCall } from 'owa-fileprovider-items-service';
import GetFileProviderItemsResponse from '../../types/GetFileProviderItemsResponse';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';

// If an error is encountered and the promise is broken we throw an AttachmentResultCode that is handled by the caller.
export default async function searchFileProviderItems(
    fileProviderType: AttachmentDataProviderType,
    fileProviderId: string,
    searchQuery: string,
    offset?: number,
    folderId?: string,
    location?: string,
    pagingMetadata: AttachmentItemsPagingMetadata = null,
    sort?: AttachmentItemsSort
): Promise<GetFileProviderItemsResponse> {
    const response = await searchFileProviderItemsServiceCall(
        fileProviderType,
        fileProviderId,
        searchQuery,
        folderId,
        location,
        pagingMetadata,
        sort
    );
    const items = handleGetOrSearchFileProviderItemsResponse(response, fileProviderId);
    return {
        items: items,
        totalItemsCount: response.TotalItemCount,
        pagingMetadata: response.PagingMetadata,
    };
}
